// extracted by mini-css-extract-plugin
export var width100 = "y_bz f_bz";
export var design3Pos = "y_vg f_b3";